import { Component, output } from '@angular/core';
import { Observable } from 'rxjs';
import { IBalancesList, ISwitchMenuItem } from '@libs/interfaces';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SpinnerComponent } from '@libs/stand-alone-components/commons/spinner/spinner';
import { ButtonLeetbitComponent } from '@libs/stand-alone-components/commons/button-ldb/button-ldb';
import { WalletBalanceRowComponent } from './wallet-balance-row/wallet-balance-row.component';
import { BalanceUserService } from '@libs/app.services/wallet/balance-user.service';

@Component({
  selector: 'app-wallet-select',
  templateUrl: './wallet-select.component.html',
  styleUrls: ['./wallet-select.component.scss'],

  imports: [CommonModule, TranslateModule, WalletBalanceRowComponent, ButtonLeetbitComponent, SpinnerComponent],
})
export class WalletSelectComponent {
  data$ = this.balanceUserService.fetchBalances();
  displayFiat$: Observable<ISwitchMenuItem>;
  onselect = output<void>();
  constructor(private balanceUserService: BalanceUserService) {}

  onViewAll(balances: IBalancesList) {
    balances.balances_crypto_show = [...balances.balances_crypto];
    balances.all = true;
  }
  onSelect() {
    this.onselect.emit();
  }
}
